import type { RouteRecordRaw } from "vue-router";

export const legalRoutes: RouteRecordRaw[] = [
  {
    path: "/gdpr",
    name: "gdpr",
    component: () => import(/* webpackChunkName: "dashboard-gdpr" */ "../../components/gdpr/GdprView.vue"),
    meta: { titleKey: "pageTitle.gdpr", viewGroup: "gdpr" }
  },
  {
    path: "/plus",
    name: "youpark-plus",
    component: () => import(/* webpackChunkName: "dashboard-plus" */ "../../components/plus/YouparkPlusView.vue"),
    meta: { titleKey: "pageTitle.youparkPlus", viewGroup: "youpark-plus" }
  },
  {
    path: "/plus/terms",
    name: "youpark-plus-terms",
    component: () => import(/* webpackChunkName: "dashboard-plus" */ "../../components/legal/YouparkPlusTermsView.vue"),
    meta: { titleKey: "pageTitle.youparkPlusTerms", viewGroup: "youpark-plus-terms" }
  },
  {
    path: "/plus/start",
    name: "youpark-plus-start",
    component: () => import(/* webpackChunkName: "dashboard-plus" */ "../../components/plus/YouparkPlusStartView.vue"),
    meta: { titleKey: "pageTitle.youparkPlusStart", viewGroup: "youpark-plus-start" }
  },
  {
    path: "/plus/status",
    name: "youpark-plus-status",
    component: () => import(/* webpackChunkName: "dashboard-plus" */ "../../components/plus/YouparkPlusStatusView.vue"),
    meta: { titleKey: "pageTitle.youparkPlusStatus", viewGroup: "youpark-plus-status" }
  },
  {
    path: "/cookies",
    name: "cookies",
    component: () => import(/* webpackChunkName: "dashboard-legal" */ "../../components/legal/CookiesView.vue"),
    meta: { titleKey: "pageTitle.cookies", viewGroup: "cookies" }
  },
  {
    path: "/privacypolicy",
    name: "privacypolicy",
    component: () => import(/* webpackChunkName: "dashboard-legal" */ "../../components/legal/PrivacyPolicyView.vue"),
    meta: { titleKey: "pageTitle.privacyPolicy", viewGroup: "privacypolicy" }
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import(/* webpackChunkName: "dashboard-legal" */ "../../components/legal/TermsConditionsView.vue"),
    meta: { titleKey: "pageTitle.termsConditions", viewGroup: "terms" }
  },
  {
    path: "/dataprocessors",
    name: "dataprocessors",
    component: () => import(/* webpackChunkName: "dashboard-legal" */ "../../components/legal/DataProcessorsView.vue"),
    meta: { titleKey: "pageTitle.dataProcessors", viewGroup: "dataprocessors" }
  }
];
